<template>
  <div>
    <iframe
      :src="iframeUrl"
      width="100%"
      height="760"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
export default {
  props: {
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iframeUrl: '',
    };
  },
  mounted(){
	this.loading = true;
  if(this.customerCode === 'PT201905021782' || this.customerCode === '201808014924')
  {
      this.iframeUrl = this.$ls.get('lang') === 'zh' ? 'https://www.mcpsystem.com/GMSTankDistributionStatistic/index_worldDJZh.html?CustomerCode=' + this.customerCode
      : 'https://www.mcpsystem.com/GMSTankDistributionStatistic/index_worldDJ.html?CustomerCode=' + this.customerCode;// 要嵌入的网址
  }
  else{
      this.iframeUrl = this.$ls.get('lang') === 'zh' ? 'https://www.mcpsystem.com/GMSTankDistributionStatistic/index_worldFuYuanZh.html?CustomerCode=' + this.customerCode
      : 'https://www.mcpsystem.com/GMSTankDistributionStatistic/index_worldFuYuanEn.html?CustomerCode=' + this.customerCode;// 要嵌入的网址
  }
},
  methods: {
    adjustIframe() {
        var ifm = document.getElementById('ifm');
        // 实际高度
        const height = document.documentElement.clientHeight;
        // 实际宽度
        const width = document.documentElement.clientWidth;
        // 父元素的宽度
        const contentWidth = this.$refs.content.offsetWidth;
        // iframe显示宽度：为了不出现横向滚动条，保险起见，减去10像素
        ifm.width = Number(contentWidth) - 10;
        // iframe显示高度：加上80像素，增加页面下方留白，看起来更舒适
        ifm.height = Number(height * ifm.width / width) - 100;
        // 加载完成后去掉加载效果
        this.loading = false;
     }
  },
}
</script>
